<template>
	<div v-if="supplierCode && !isFetchingSupplierStore" class="bordered bg-white mb-4" :class="cardWidth">
		<div class="logo-container px-2 m-2 d-flex align-items-center">
			<img v-if="supplierStore && supplierStore.logo && supplierStore.logo !== ''" :src="supplierStore.logo" alt="">
			<img v-else src="/images/ostock-logo-gram.png">
		</div>
		<div class="my-2">
			<div class="supplier-name" v-if="supplierStore">{{ supplierStore.name }}</div>
			<div class="supplier-code" v-if="supplierCode">
				<small>
					{{ supplierCode }}
				</small>
			</div>
			<div v-if="!storeAvailability" class="store-availability d-flex align-items-center">
				<i class="bi bi-clock-fill mr-1"></i>
				<span class="text-bold">Toko Sedang Libur</span>
			</div>
			<div class="supplier-origin">
				<small class="text-bold">Warehouse : </small>
				<small v-if="showSupplierOrigin">
					{{ supplierOriginShippingAddress }} - {{ supplierOrigin }}
				</small>
				<small v-else>
					<router-link :to="`/login?redirect=/supplier/${supplierCode}`" class="mr-2">
						<span class="text-primary">Login untuk melihat</span>
					</router-link>
				</small>
			</div>
			<div v-if="fullWidth" class="mb-2 total-products">
				<span class="text-bold">Total Produk :</span> {{ totalProducts }}
			</div>
			<router-link v-else :to="`/supplier/${supplierCode}`">
				<button type="button" class="btn btn-primary my-2" :class="btnSm">
					Lihat Produk Supplier
				</button>
			</router-link>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import homepageApi from '@/api/homepage';
// import supplier from '@/api/supplier';
import {
	duplicateVar,
	getAxiosErrorMessage,
} from '@/lib/helper';

export default {
	props: {
		supplierCode: {
			type: String,
			default: '',
		},
		supplierOrigin: {
			type: String,
			default: '',
		},
		fullWidth: {
			type: Boolean,
			default: false,
		},
		showLabel: {
			type: Boolean,
			default: false,
		},
		totalProducts: {
			type: Number,
			default: 0,
		},
		storeAvailability: {
			type: Boolean,
			default: true,
		},
		store: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			isScreenSmall: window.innerWidth <= 768,
			supplierStore: null,
			isFetchingSupplierStore: false,
			supplierOriginShippingAddress: '',
		};
	},
	methods: {
		init() {
			this.isFetchingSupplierStore = true;
			if (this.supplierCode && (!this.store || this.store === null)) {
				this.getSupplierDetail();
			} else {
				this.isFetchingSupplierStore = false;
				this.supplierStore = duplicateVar(this.store);
			}
		},
		updateScreenSize() {
			// Update the `isScreenSmall` property based on the window width
			this.isScreenSmall = window.innerWidth <= 768;
		},
		getSupplierDetail() {
			const params = {
				supplier_code: this.supplierCode,
			};

			const callback = (response) => {
				this.isFetchingSupplierStore = false;
				this.supplierStore = response?.data?.store || null;
				this.supplierOriginShippingAddress = this.supplierStore?.shipping?.origin?.address || '';
			};

			const errorCallback = (e) => {
				this.isFetchingSupplierStore = false;
				const message = getAxiosErrorMessage(e);
				console.log('message: ', message);
			};

			homepageApi.getSupplierDetail(params, callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isLoggedIn: 'isLoggedIn',
		}),
		cardWidth() {
			return {
				'pr-4 mx-4 mt-4': !this.fullWidth,
				'd-inline-flex': !this.fullWidth && !this.isScreenSmall,
				'd-flex': this.fullWidth || this.isScreenSmall,
			};
		},
		btnSm() {
			return {
				'btn-sm': this.isScreenSmall,
			};
		},
		showSupplierOrigin() {
			return this.isLoggedIn && this.supplierOrigin && (this.supplierOriginShippingAddress && this.supplierOriginShippingAddress !== '');
		},
	},
	mounted() {
		this.init();
		// Add a window resize event listener to update the `isScreenSmall` data property
		window.addEventListener('resize', this.updateScreenSize);
	},
	beforeDestroy() {
		// Remove the event listener when the component is destroyed
		window.removeEventListener('resize', this.updateScreenSize);
	},
};
</script>

<style scoped>
.bordered {
	border: 1px solid rgba(0, 0, 0, .15);
	border-radius: 5px;
}

.logo-container {
	max-width: 100px;
}

.supplier-name {
	font-size: 20px;
	font-weight: 600;
}

.supplier-origin, .total-products {
	font-size: 16px;
}

.store-availability {
	font-size: 14px;
	color: #F28900;
}

@media only screen and (max-width: 768px) {
	.logo-container {
		max-width: 75px;
	}

	.supplier-code {
		font-size: 20px;
	}

	.supplier-origin, .total-products {
		font-size: 12px;
	}

	.store-availability {
		font-size: 10px;
	}
}
</style>
